//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Dialog } from 'vant';
import { getInfo } from "@/api/my";
import Afooter from '@/components/Afooter'
export default {
  name: 'mine',
  components: {
    Afooter
  },
  data: function () {
    return {
      title: '我的',
      userInfo: {}
    }
  },
  created () {
    if (navigator.userAgent.includes('AppleWebKit')) {
      this.isIphone = true
    }
    this.getUser()
  },
  mounted () {
  },
  activated () {
    this.getUser()
  },
  methods: {
    formDate (timestamp) {
      let date = new Date(timestamp)
      let currentDate = new Date()
      let year = date.getFullYear()
      let coutYear = year - currentDate.getFullYear()
      if (coutYear > 50) {
        return '永久会员'
      }
      let month = date.getMonth() + 1
      let day = date.getDate()
      return year + '-' + month + '-' + day
    },
    goIntegral () {
      this.$toast('功能陆续开放中 敬请期待')
    },
    getUser () {
      if (global.isApp && !localStorage.getItem("deviceId")) {
        return;
      }
      if (!global.isApp && !localStorage.getItem("uuid")) {
        return;
      }
      if (!localStorage.getItem("token")) {
        return;
      }
      if (global.isApp && !localStorage.getItem("showAgree")) {
        return;
      }
      console.log("home: info");
      getInfo().then((res) => {
        this.userInfo = res.data;
        if (res && res.data && res.data.unionId) {
          localStorage.setItem("unionId", res.data.unionId);
        } else {
          localStorage.removeItem("wxToken");
          localStorage.removeItem("unionId");
        }
      });
    },
    goChat (type) {
      this.$router.push({
        path: '/chat?type=' + encodeURIComponent(type)
      })
    },
    goInvite () {
      this.$router.push({
        path: '/mine/invite'
      })
    },
    goPrivacy () {
      this.$router.push({
        path: '/privacy'
      })
    },
    goAgree () {
      this.$router.push({
        path: '/userAgreement'
      })
    },
    goAbout () {
      this.$router.push({
        path: '/about'
      })
    },
    goReport () {
      this.$router.push({
        path: '/mine/report'
      })
    },
    goWork () {
      this.$router.push({
        path: '/mine/cooperate'
      })
    },
    logout () {
      let _this = this
      Dialog.confirm({
        title: '提示',
        message: '确定要退出登录吗?',
        // confirmButtonColor: '#30b8b8',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // cancelButtonColor: '#999999',
      })
        .then(() => {
          localStorage.removeItem('userInfo')
          localStorage.removeItem('detail')
          localStorage.removeItem('token');
          _this.$router.replace({
            path: '/login'
          })
        })
        .catch(() => { })
    },
    goSubscribe () {
      // this.$router.push({
      //   path: '/subscribe'
      // })
      this.$router.push({
        path: '/subscribe'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Mine/mine.vue